import React, { useState, useEffect } from "react";
import vectorImage from "../../images/newHome/iot-vector.png"
import ThemeButton from "./ThemeButton";
import { Link } from "react-router-dom";
import SectionTitle from "./SectionTitle";

function HeroSection() {
    return (
        <>
            <div className="relative flex items-center min-h-[610px] overflow-hidden">
                {/* Background shape */}
                <div className="hidden lg:block absolute top-0 left-0 w-full lg:w-[51%] h-full bg-primaryColor z-0 lg:rounded-bl-none lg:rounded-br-[400px]"></div>

                {/* Hero Content */}
                <div className="grid grid-cols-1 lg:grid-cols-2 lg:container z-10 mobile-px">
                    {/* Left Column (Text) */}
                    <div className="px-6 sm:px-0 sm:py-0 w-full order-2 lg:order-1 flex items-center lg:pr-6 bg-primaryColor lg:bg-transparent rounded-br-[124px] rounded-bl-[124px]">
                        <div className="py-11">
                            <SectionTitle
                                size="mb-6 font-inter text-[32px] lg:text-[41px] xl:text-[61px]"
                                weight="font-semibold"
                                color="text-white"
                                align = "text-center lg:text-left"
                                className="leading-[130%] no-underline"
                            >
                                A Smarter Way to Product Compliance
                            </SectionTitle>
                            <div className="text-center lg:text-left mt-3">
                                <p className="font-inter mb-12 font-normal text-base lg:text-xl leading-[27px] text-white no-underline">
                                    Simplify your compliance journey with expert testing, seamless certification, and trusted lab
                                    partnerships—ensuring your products meet global regulatory standards efficiently.
                                </p>
                            </div>
                            <div className="sm:max-w-[85%] sm:mx-auto lg:max-w-none lg:mx-0 flex flex-wrap gap-3 lg:gap-6 mt-4 sm:w-full px-4 py-1 lg:px-[unset] lg:py-[unset]">
                                <ThemeButton
                                    bgColor="bg-white"
                                    textColor="text-primaryColor"
                                    padding="w-full lg:w-auto xl:px-6 lg:px-4 py-3"
                                    size="text-sm xl:text-lg lg:text-base"
                                    border="border-0"
                                    rounded="rounded-none"
                                    className="leading-[28px] font-semibold cursor-pointer"
                                >
                                    Get Started Now
                                </ThemeButton>
                                <Link
                                    to="/reserve-lab"
                                    className={`w-full lg:w-auto ttnc-logo inline-block`}
                                >
                                    <ThemeButton
                                        bgColor="bg-transparent"
                                        textColor="text-white"
                                        padding="w-full lg:w-auto xl:px-6 lg:px-4 py-3"
                                        size="text-sm xl:text-lg lg:text-base"
                                        border="border border-white"
                                        rounded="rounded-none"
                                        className="leading-[28px] font-semibold cursor-pointer"
                                    >
                                        Reserve a Lab Today
                                    </ThemeButton>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Right Column (Image) */}
                    <div className="w-full order-1 lg:order-2 px-4 md:px-6 text-right">
                        <img
                            className="w-full pl-3 lg:max-w-[636px]"
                            src={vectorImage}
                            alt="Iot vector"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default HeroSection;